module.exports = __webpack_public_path__ + "img/6.5533f6e8.png";